import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SnackbarProvider } from 'notistack';
import { Provider } from 'react-redux';
import store from './state/store'; 

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <div className='main-container'>
        <SnackbarProvider maxSnack={1}>
          <App />
        </SnackbarProvider>
      </div>  
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
